import { Pipe, PipeTransform } from '@angular/core';
import { yesNo } from 'src/app/utils/boolean.utils';

@Pipe({
    name: 'yesNo',
    standalone: false
})
export class YesNo implements PipeTransform {
    /**
     */
    transform(value: string, capitalize?: boolean): string {
        return yesNo(value, capitalize);
    }
}
